import { Component } from '@theme/component';
import { ThemeEvents, ZoomMediaSelectedEvent } from '@theme/events';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, { signal });

    this.refs.zoomDialogComponent?.addEventListener(
      ThemeEvents.zoomMediaSelected,
      this.#handleZoomMediaSelected,
      { signal }
    );

    if (this.dataset.productFeaturedMediaId) {
      requestAnimationFrame(() => {
        this.#setInitialFeaturedMedia();
      });
    }
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #setInitialFeaturedMedia() {
    const featuredMediaId = this.dataset.productFeaturedMediaId;

    if (!featuredMediaId) return;

    const currentMedia = this.querySelector('.product-media');

    if (!currentMedia || currentMedia.dataset.mediaId === featuredMediaId) return;

    const longImage = this.parentElement?.querySelector(
      `.product-long-images__item[data-media-id="${featuredMediaId}"]`
    );

    const currentImage = currentMedia.querySelector('.product-media__image');
    const image = longImage?.querySelector('img');

    if (!image || !currentImage) return;

    currentImage.src = image.getAttribute('src') || image.src;
    currentImage.srcset = image.getAttribute('srcset') || '';
    currentImage.sizes = image.getAttribute('sizes') || '';
    currentImage.alt = image.alt;

    currentMedia.dataset.mediaId = featuredMediaId;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html } = detail;

        const newMediaGallery = html.querySelector('media-gallery');

        if (!newMediaGallery) return;

        const currentLongImages = this.parentElement?.querySelector('.product-long-images');
        const newLongImages = html.querySelector('.product-long-images');

        // สำคัญ:
        // Gallery ที่โหลดหลังจากกด Variant แล้ว
        // ห้ามให้ logic "initial product featured image" ทำงานซ้ำ
        newMediaGallery.removeAttribute('data-product-featured-media-id');

        this.replaceWith(newMediaGallery);

        if (currentLongImages) {
          if (newLongImages) {
            currentLongImages.replaceWith(newLongImages);
          } else {
            currentLongImages.remove();
          }
        } else if (newLongImages) {
          newMediaGallery.parentElement?.append(newLongImages);
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[media-gallery] Event promise rejected:', error);
        }
      });
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];

    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}